module.exports = __webpack_public_path__ + "media/images/prestaciones/asma-a2d5661fc66629e3357eaf76a88205dc.svg";